@let $storageType = storageTypeCtrl.value;
@let $isAvailableRegion = $storageType | isAvailableRegion;

<mbs-modal
  [loading]="loading()"
  [title]="moduleAccount + ':modal.title.addBackupDestination' | i18next: { format: 'capitalize' }">
  <ng-container modal-body>
    <mbs-form-section>
      <app-storage-settings-form
        [appendTo]="'.modal-content'"
        [formGroup]="formGroup"
        [initialSettings]="initialSettings()"
        [storages]="storages()" />
    </mbs-form-section>

    @if (!$isAvailableRegion) {
      <mbs-form-section>
        <div class="form-row">
          <div class="col-auto">
            <mbs-button
              [disabled]="!formGroup.valid"
              [loading]="testLoading()"
              [type]="'secondary'"
              (click)="handleTest()">
              {{ moduleAccount + ':sidepanel.button.testAccess' | i18next: { format: 'capitalize' } }}
            </mbs-button>
          </div>
        </div>
      </mbs-form-section>
    }
  </ng-container>

  <ng-container modalFooter>
    <mbs-button
      [disabled]="!formGroup.valid"
      [loading]="buttonLoading()"
      [type]="'primary'"
      (click)="handleSave()">
      {{ moduleButton + ':button.save' | i18next: { format: 'capitalize' } }}
    </mbs-button>

    <mbs-button (click)="handleCancel()">
      {{ moduleButton + ':button.cancel' | i18next: { format: 'capitalize' } }}
    </mbs-button>
  </ng-container>
</mbs-modal>

<ng-template #backupDConfirmTRef>
  <mbs-alert
    class="mb-0"
    [icon]="true"
    [type]="MbsPopupType.warning">
    {{ moduleAccount + ':modal.body.specifiedBackupDestination' | i18next: { format: 'capitalize' } }}?
  </mbs-alert>
</ng-template>
